window.WaterdealCore = Object.freeze({
  recommend(values, products) {
    const measured = !values.unknown_size;
    if (values.place === 'balcony') return {kind:'balcony',results:[],measured};
    if (values.pipe === 'no') return {kind:'pipe',results:[],measured};
    const fits = products.filter(p => p.cap > 0 && (!measured || p.width > 0 && p.height > 0 && p.width <= Number(values.width) && p.height <= Number(values.height)));
    const target = {light:100,regular:250,intensive:500,unknown:100}[values.use] || 100;
    const available = fits.filter(p => p.available).sort((a,b) => Math.abs(a.cap-target)-Math.abs(b.cap-target) || a.cap-b.cap);
    const results = available.slice(0,1);
    const alternate = available.filter(p => p.id !== results[0]?.id).sort((a,b) => a.cap-b.cap)[0];
    if (alternate) results.push(alternate);
    return {kind:!fits.length?'no_fit':!available.length?'sold_out':'suggested',results,fits,available,measured};
  },
  calculate(v, larger = null, years = 1) {
    const amount = (value, max = Infinity) => Number.isFinite(Number(value)) ? Math.min(max, Math.max(0, Number(value))) : 0;
    const potential = amount(v.roof) * amount(v.rain) * amount(v.efficiency, 100) / 100;
    const annualUse = amount(v.use) * amount(v.weeks, 52);
    const useful = Math.min(potential, annualUse, amount(v.capacity) * amount(v.fills, 365));
    const extra = larger ? Math.max(0, Math.min(potential, annualUse, amount(larger) * amount(v.fills, 365)) - useful) : 0;
    const saving = useful / 1000 * amount(v.rate);
    const period = [1, 5, 10].includes(Number(years)) ? Number(years) : 1;
    return {potential,annualUse,useful,saving,extra,years:period,totalSaving:saving*period,cans:Math.floor(useful/10)};
  }
});
(() => {
  'use strict';
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  const parse = el => { try { return JSON.parse(el?.textContent || '{}'); } catch { return {}; } };
  const config = parse($('#w-config'));
  const route = path => `${config.root || '/'}${path}`;
  const galleryOffset = (gallery, slide) => gallery.scrollLeft + slide.getBoundingClientRect().left - gallery.getBoundingClientRect().left;
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', {style:'currency', currency:config.currency || 'EUR'}).format(cents / 100);
  const number = n => new Intl.NumberFormat('nl-NL', {maximumFractionDigits:0}).format(n);
  const track = (name, data = {}) => {
    if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true && Array.isArray(window.dataLayer)) {
      window.dataLayer.push({event:`waterdeal_${name}`, ...data});
    }
  };
  const showError = (el, message) => { if (el) { el.textContent = message; el.hidden = !message; } };
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const motionEnabled = () => config.motion !== false && !reducedMotion.matches && !document.documentElement.classList.contains('w-reduce-motion');
  const numberAnimations = new Map();
  const animateNumber = (el, value, format = number, from = 0, animate = true) => {
    if (!el) return;
    const previous = numberAnimations.get(el);
    if (previous) cancelAnimationFrame(previous.frame);
    numberAnimations.delete(el);
    const end = Number(value);
    if (!Number.isFinite(end)) return;
    el.dataset.numericValue = String(end);
    if (!animate || !motionEnabled() || !el.getClientRects().length || end === from) { el.textContent = format(end); return; }
    const state = {end,format,frame:0}, start = performance.now();
    const tick = time => {
      if (!el.isConnected || !motionEnabled()) { el.textContent=format(end); numberAnimations.delete(el); return; }
      const progress=Math.min(1,(time-start)/800), eased=1-Math.pow(1-progress,3);
      el.textContent=format(from+(end-from)*eased);
      if (progress<1) state.frame=requestAnimationFrame(tick);
      else { el.textContent=format(end); numberAnimations.delete(el); }
    };
    numberAnimations.set(el,state);state.frame=requestAnimationFrame(tick);
  };
  const finishNumbers = () => numberAnimations.forEach((state,el)=>{cancelAnimationFrame(state.frame);el.textContent=state.format(state.end);numberAnimations.delete(el);});
  const animateStep = (el,direction=1) => {
    if (el?.animate && motionEnabled()) el.animate([{opacity:.35,transform:`translateX(${direction*14}px)`},{opacity:1,transform:'translateX(0)'}],{duration:300,easing:'cubic-bezier(.16,1,.3,1)'});
  };
  const dialogState = new WeakMap();
  const closeDialog = dialog => {
    if (!dialog?.open || dialog.classList.contains('is-closing')) return;
    if (!motionEnabled()) { dialog.close(); return; }
    dialog.classList.add('is-closing');
    dialogState.get(dialog).timer = setTimeout(() => dialog.close(), 170);
  };
  const bindDialog = dialog => {
    if (dialogState.has(dialog)) return;
    const state = {opener:null,timer:null};
    dialogState.set(dialog,state);
    dialog.addEventListener('close', () => {
      if (dialog.open) return;
      clearTimeout(state.timer);
      dialog.classList.remove('is-closing');
      if (!$('dialog[open]')) {
        document.documentElement.classList.remove('w-modal-open');
        if (state.opener?.isConnected) state.opener.focus({preventScroll:true});
      }
    });
    dialog.addEventListener('cancel', e => { e.preventDefault(); closeDialog(dialog); });
    dialog.addEventListener('click', e => {
      if (e.target !== dialog) return;
      const r = dialog.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) closeDialog(dialog);
    });
  };
  const openDialog = dialog => {
    if (!dialog?.showModal) return false;
    bindDialog(dialog);
    const state = dialogState.get(dialog);
    clearTimeout(state.timer);
    dialog.classList.remove('is-closing');
    if (dialog.open) return true;
    state.opener = document.activeElement;
    const menu = state.opener?.closest('.w-mobile-nav');
    if (menu) { state.opener = $('summary',menu); menu.open = false; }
    $$('dialog[open]').forEach(other => { if (other !== dialog) other.close(); });
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('w-modal-open');
    return true;
  };
  $$('dialog').forEach(bindDialog);
  const cartDialog = $('#w-cart-dialog');
  let cartBusy = false;
  const cartSections = () => [...new Set($$('[data-cart-section]').map(el => el.dataset.cartSection))];
  const setCartBusy = busy => {
    cartBusy = busy;
    $$('[data-cart-form]').forEach(form => { form.setAttribute('aria-busy', String(busy)); $$('button,input', form).forEach(el => { el.disabled = busy; }); });
  };
  const paintCart = sections => {
    let updated = 0;
    $$('[data-cart-section]').forEach(container => {
      const html = sections?.[container.dataset.cartSection];
      if (!html) return;
      const source = new DOMParser().parseFromString(html, 'text/html');
      const content = $('[data-cart-content]', source);
      const current = $('[data-cart-content]', container);
      if (content && current) { current.replaceWith(content); updated++; }
    });
    const count = Number($('[data-cart-content]')?.dataset.count || 0);
    $$('[data-cart-count]').forEach(el => { const changed=Number(el.textContent)!==count;el.textContent=count;if(changed&&motionEnabled())el.animate([{transform:'scale(1)'},{transform:'scale(1.22)'},{transform:'scale(1)'}],{duration:350}); });
    $$('[data-cart-open]').forEach(el => el.setAttribute('aria-label', `Winkelwagen, ${count} artikelen`));
    return updated;
  };
  const refreshCart = async () => {
    const url = new URL(location.href); url.searchParams.set('sections', cartSections().join(','));
    const res = await fetch(url, {headers:{Accept:'application/json'}});
    if (!res.ok || !paintCart(await res.json())) throw new Error('Je winkelwagen kon niet worden bijgewerkt. Open de winkelwagen opnieuw.');
  };
  const responseJSON = async res => {
    const data = await res.json();
    if (!res.ok) throw new Error(typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : 'Dit aantal kan nu niet worden besteld. Controleer de beschikbare voorraad.');
    return data;
  };
  const changeCart = async (key, quantity, input) => {
    if (cartBusy) return;
    const errors = $$('[data-cart-error]'); errors.forEach(el => showError(el, ''));
    const previous = input?.defaultValue;
    setCartBusy(true);
    try {
      const data = await responseJSON(await fetch(route('cart/change.js'), {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify({id:key, quantity, sections:cartSections(), sections_url:location.pathname})}));
      if (!paintCart(data.sections)) await refreshCart();
    } catch (error) {
      if (input?.isConnected && previous !== undefined) input.value = previous;
      errors.forEach(el => showError(el, error.message || 'Geen verbinding. Probeer het opnieuw.'));
    } finally { setCartBusy(false); }
  };
  document.addEventListener('click', e => {
    const close = e.target.closest('[data-dialog-close]');
    if (close) { closeDialog(close.closest('dialog')); return; }
    const openCart = e.target.closest('[data-cart-open]');
    if (openCart && openDialog(cartDialog)) {
      e.preventDefault();
      refreshCart().catch(() => showError($('[data-cart-error]', cartDialog), 'Laden lukt niet. Je kunt ook de volledige winkelwagen openen.'));
      return;
    }
    const continueLink = e.target.closest('[data-continue-shopping]');
    if (continueLink?.closest('dialog')) { e.preventDefault(); closeDialog(continueLink.closest('dialog')); return; }
    const qty = e.target.closest('[data-qty-step]');
    if (qty) {
      const input = $('input', qty.closest('.w-qty'));
      if (!input || input.disabled) return;
      try { Number(qty.dataset.qtyStep) > 0 ? input.stepUp() : input.stepDown(); } catch { return; }
      input.dispatchEvent(new Event('change', {bubbles:true}));
    }
    const remove = e.target.closest('[data-cart-remove]');
    if (remove) { e.preventDefault(); if (!cartBusy) changeCart(remove.closest('[data-cart-key]').dataset.cartKey, 0); }
  });
  document.addEventListener('change', e => {
    if (e.target.matches('[data-auto-submit]')) e.target.form.requestSubmit();
    if (e.target.matches('[data-cart-quantity]')) {
      const input = e.target;
      if (!input.reportValidity() || input.value === '') return;
      changeCart(input.closest('[data-cart-key]').dataset.cartKey, Number(input.value), input);
    }
  });
  document.addEventListener('submit', e => {
    if (e.target.matches('[data-cart-form]') && e.submitter?.name === 'checkout') {
      if (cartBusy) e.preventDefault(); else track('begin_checkout');
    }
  });
  const initProductInfo = root => {
    const dialog = $('[data-product-info-dialog]',root);
    if (!dialog?.showModal) return;
    bindDialog(dialog);
    const library = $('[data-info-library]',root);
    if (library) library.hidden = true;
    const body = $('[data-info-body]',dialog), title = $('[data-info-title]',dialog);
    let source = null, placeholder = null;
    const restore = () => {
      if (source && placeholder?.isConnected) placeholder.replaceWith(source);
      source = null; placeholder = null;
      body.replaceChildren();
    };
    dialog.addEventListener('close',() => { if (!dialog.open) restore(); });
    root.addEventListener('click',e => {
      const trigger = e.target.closest('[data-product-info]');
      if (!trigger || !root.contains(trigger)) return;
      const key = trigger.dataset.productInfo;
      const content = $(`[data-info-source="${key}"]`,root);
      const template = $(`[data-info-template="${key}"]`,root);
      if (!content && !template) return;
      e.preventDefault(); restore();
      title.textContent = trigger.textContent.trim();
      if (content) {
        source = content;
        placeholder = document.createElement('div');
        placeholder.style.height = `${content.getBoundingClientRect().height}px`;
        placeholder.setAttribute('aria-hidden','true');
        content.before(placeholder); body.append(content);
      } else body.append(template.content.cloneNode(true));
      if (!openDialog(dialog)) { restore(); return; }
      body.scrollTop = 0;
      title.focus({preventScroll:true});
      track('product_information_opened',{topic:key});
    });
    root.closest('.shopify-section')?.addEventListener('shopify:section:unload',() => {
      if (dialog.open) dialog.close();
      restore();
    });
  };
  const initProduct = root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    initProductInfo(root);
    const data = parse($('[data-product-json]', root));
    const form = $('[data-product-form]', root), select = $('[data-variant-select]', root);
    if (!form || !select || !Array.isArray(data.variants)) return;
    let variant = data.variants.find(v => String(v.id) === select.value) || data.variants[0];
    let pending = false;
    const buttons = $$('[data-product-add],[data-sticky-add]', root);
    const setVariant = (updateUrl = false) => {
      variant = data.variants.find(v => String(v.id) === select.value);
      if (!variant) return;
      $$('[data-product-price],[data-sticky-price]', root).forEach(el => { el.textContent = money(variant.price); });
      const compare = $('[data-product-compare]', root); compare.hidden = !(variant.compare_at_price > variant.price); compare.textContent = money(variant.compare_at_price || 0);
      $('[data-product-availability]', root).textContent = data.delivery?.[variant.id] || (variant.available ? config.delivery : 'Tijdelijk uitverkocht');
      $('[data-product-shipping]', root).textContent = config.country === 'NL' && config.currency === 'EUR' ? (config.threshold > 0 && variant.price >= config.threshold ? 'Gratis verzending in Nederland' : `${money(config.shipping)} verzending in Nederland`) : 'Verzendkosten bij de kassa';
      buttons.forEach(button => { button.disabled = !variant.available || pending; });
      $$('[data-add-label]', root).forEach(el => { el.textContent = variant.available ? 'In winkelwagen' : 'Uitverkocht'; });
      $('[data-sticky-variant]', root).textContent = data.single ? '' : `${variant.title} · `;
      const sku = $('[data-product-sku]', root); if (sku) { sku.textContent = variant.sku || ''; $('[data-sku-row]', root).hidden = !variant.sku; }
      const qty = $('[name="quantity"]', form), rule = data.rules?.[variant.id] || {min:1,step:1,max:null};
      qty.min = rule.min || 1; qty.step = rule.step || 1;
      if (rule.max != null) qty.max = rule.max; else qty.removeAttribute('max');
      if (!qty.checkValidity()) qty.value = rule.min || 1;
      showError($('[data-product-error]', root), '');
      if (updateUrl) { const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url); }
      const mediaId = data.media?.[variant.id] || variant.featured_media?.id || variant.featured_image?.id;
      if (mediaId) { const media = $(`[data-media-id="${mediaId}"]`, root); if (media) $('[data-gallery]', root).scrollTo({left:galleryOffset($('[data-gallery]', root),media),behavior:motionEnabled() ? 'smooth' : 'instant'}); }
    };
    select.addEventListener('change', () => setVariant(true));
    setVariant();
    track('view_item', {variant_id:variant?.id, value:variant?.price / 100, currency:config.currency});
    form.addEventListener('submit', async e => {
      e.preventDefault();
      if (pending || !variant?.available || !form.reportValidity()) return;
      pending = true; buttons.forEach(b => { b.disabled = true; b.setAttribute('aria-busy','true'); }); select.disabled = true;
      showError($('[data-product-error]', root), '');
      let added = false;
      try {
        const payload = new FormData(form); payload.set('id', variant.id); payload.set('sections', cartSections().join(',')); payload.set('sections_url', location.pathname);
        const response = await responseJSON(await fetch(route('cart/add.js'), {method:'POST', headers:{Accept:'application/json'}, body:payload}));
        added = true;
        track('add_to_cart', {variant_id:variant.id, quantity:Number(payload.get('quantity') || 1), value:variant.price / 100, currency:config.currency});
        if (!paintCart(response.sections)) await refreshCart();
        if (!openDialog(cartDialog)) location.assign(route('cart'));
      } catch (error) {
        if (added) location.assign(route('cart'));
        else showError($('[data-product-error]', root), error.message || 'Geen verbinding. Probeer het opnieuw.');
      } finally { pending = false; select.disabled = false; buttons.forEach(b => { b.disabled = !variant?.available; b.removeAttribute('aria-busy'); }); }
    });
    const gallery = $('[data-gallery]', root), thumbs = $$('[data-gallery-go]', root);
    const slides = $$('.w-gallery-item',gallery), toolbar=$('[data-gallery-toolbar]',root), zoom=$('[data-gallery-zoom]',root), imageDialog=$('[data-gallery-dialog]',root);
    let galleryIndex=0,scrollFrame;
    const galleryState=()=>{
      galleryIndex=Math.max(0,Math.min(slides.length-1,Math.round(gallery.scrollLeft/gallery.clientWidth)));
      thumbs.forEach((button,i)=>button.setAttribute('aria-current',String(i===galleryIndex)));
      const counter=$('[data-gallery-index]',root);if(counter)counter.textContent=String(galleryIndex+1);
      const prev=$('[data-gallery-prev]',root),next=$('[data-gallery-next]',root);
      if(prev)prev.disabled=galleryIndex===0;if(next)next.disabled=galleryIndex>=slides.length-1;
      if(zoom)zoom.hidden=!imageDialog?.showModal||!$('img',slides[galleryIndex]);
    };
    const go = index => { const slide=slides[Math.max(0,Math.min(slides.length-1,index))];if(slide)gallery.scrollTo({left:galleryOffset(gallery,slide),behavior:motionEnabled()?'smooth':'instant'}); };
    thumbs.forEach(button=>button.addEventListener('click',()=>go(Number(button.dataset.galleryGo))));
    $('[data-gallery-prev]',root)?.addEventListener('click',()=>go(galleryIndex-1));
    $('[data-gallery-next]',root)?.addEventListener('click',()=>go(galleryIndex+1));
    gallery?.addEventListener('scroll',()=>{cancelAnimationFrame(scrollFrame);scrollFrame=requestAnimationFrame(galleryState);},{passive:true});
    gallery?.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go(galleryIndex+(e.key==='ArrowRight'?1:-1));}});
    if(toolbar)toolbar.hidden=false;
    zoom?.addEventListener('click',()=>{
      const source=$('img',slides[galleryIndex]);if(!source||!imageDialog)return;
      const image=source.cloneNode();image.removeAttribute('id');image.loading='eager';image.sizes='(max-width:749px) 100vw, 900px';
      $('[data-zoom-image]',imageDialog).replaceChildren(image);openDialog(imageDialog);
    });
    imageDialog?.addEventListener('close',()=>{if(!imageDialog.open)$('[data-zoom-image]',imageDialog).replaceChildren();});
    galleryState();
    const sticky = $('[data-sticky]', root), buy = $('[data-product-add]', root);
    if ('IntersectionObserver' in window && sticky && buy) new IntersectionObserver(entries => {
      const visible = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      sticky.hidden = !visible; document.body.classList.toggle('has-sticky', visible);
    }).observe(buy);
  };
  $$('[data-product-root]').forEach(initProduct);
  document.addEventListener('shopify:section:load', e => $$('[data-product-root]', e.target).forEach(initProduct));
  const finder = $('#w-finder'), finderForm = $('[data-finder-form]'), result = $('[data-finder-result]');
  if (finder && finderForm) {
    const products = parse($('#w-finder-data'));
    const steps = $$('[data-step]', finder), error = $('[data-finder-error]', finder), next = $('[data-finder-next]', finder);
    let step = 0;
    finderForm.noValidate = true;
    const showStep = index => {
      const direction=index>=step?1:-1;step = index; result.hidden = true; finderForm.hidden = false;
      steps.forEach((el,i) => { el.hidden = i !== step; });
      $$('.w-progress li', finder).forEach((el,i) => { el.classList.toggle('is-current',i === step); el.classList.toggle('is-complete',i < step); if (i === step) el.setAttribute('aria-current','step'); else el.removeAttribute('aria-current'); });
      $('[data-finder-back]', finder).hidden = !step; $('[data-finder-spacer]', finder).hidden = !!step;
      next.textContent = step === 3 ? 'Bekijk mijn advies →' : 'Volgende stap →';
      showError(error, '');
      $('h3', steps[step])?.focus({preventScroll:true});
      $('.w-dialog-body',finder).scrollTop = 0;
      animateStep(steps[step],direction);
    };
    const addCard = product => { const template = $(`#w-finder-card-${product.id}`); if (template) $('[data-finder-cards]', finder).append(template.content.cloneNode(true)); };
    const advise = () => {
      const values = Object.fromEntries(new FormData(finderForm));
      const cards = $('[data-finder-cards]', finder); cards.replaceChildren();
      const caution = $('[data-finder-caution]', finder); caution.hidden = false;
      let copy = '', notes = [], recommended = [];
      if (values.place === 'balcony') {
        copy = 'Laat eerst beoordelen wat jouw balkon of dakterras kan dragen.';
        notes.push('Alleen al 100 liter water weegt ongeveer 100 kg, exclusief ton en ondergrond. Deze keuzehulp kan de draagkracht niet beoordelen. Vraag je verhuurder, VvE of een constructiedeskundige om advies voordat je een ton plaatst.');
      } else if (values.pipe === 'no') {
        copy = 'Bepaal eerst hoe het regenwater bij je ton komt.';
        notes.push('Zonder geschikte wateraanvoer kunnen we geen passend systeem adviseren. Stuur ons een beschrijving of foto van de plek via de contactpagina.');
      } else {
        const decision = window.WaterdealCore.recommend(values, products);
        const {measured, fits, available} = decision;
        if (!fits.length) {
          copy = 'Binnen deze breedte en hoogte vinden we geen passend formaat.';
          notes.push('Meet een andere plek of vraag ons om advies. We adviseren geen grotere ton dan de ruimte die je hebt ingevuld.');
        } else if (!available.length) {
          copy = 'De formaten binnen jouw maten zijn momenteel uitverkocht.';
          notes.push('Je kunt hieronder de productinformatie bekijken. Er is nu geen bestelbaar advies binnen deze maten.');
          fits.sort((a,b) => a.cap-b.cap).slice(0,2).forEach(addCard);
        } else {
          recommended = decision.results;
          const alternate = recommended[1];
          recommended.forEach(addCard);
          copy = `${recommended[0].cap} liter is een startpunt bij jouw gebruik${measured ? ' en valt met de ton zelf binnen de opgegeven breedte en hoogte' : ''}.`;
          if (alternate) copy += ` Daarnaast kun je ${alternate.cap} liter vergelijken.`;
          notes.push(measured ? 'Dit is geen garantie dat de volledige opstelling past. Houd extra ruimte vrij voor kraan, regenpijpaansluiting en onderhoud. Controleer ook diepte en een vlakke, draagkrachtige ondergrond.' : 'De ruimte is nog niet gecontroleerd. Meet breedte, hoogte én diepte voordat je kiest en houd extra ruimte vrij voor aansluiten en gebruik.');
          if (values.use === 'intensive') notes.push('De inhoud is een opslagkeuze, geen garantie op voldoende water voor je hele tuin. Gebruik de calculator voor een scenario.');
          if (values.pipe === 'unknown') notes.push('Controleer eerst of er een geschikte regenpijp aanwezig is.');
          else notes.push('Controleer welke koppeling past bij de vorm en diameter van je regenpijp; we voegen geen accessoires automatisch toe.');
        }
      }
      $('[data-finder-explanation]', finder).textContent = copy;
      caution.textContent = notes.join(' ');
      finderForm.hidden = true; result.hidden = false; animateStep(result);$('h3',result).focus({preventScroll:true});
      $('.w-dialog-body',finder).scrollTop = 0;
      track('finder_completed', {place:values.place, usage:values.use, measured:!values.unknown_size, recommended_capacity:recommended[0]?.cap || null});
    };
    const advance = () => {
      const values = Object.fromEntries(new FormData(finderForm));
      if (step === 0 && !values.place || step === 2 && !values.use || step === 3 && !values.pipe) { showError(error,'Kies een antwoord om verder te gaan.'); return; }
      if (step === 1 && !values.unknown_size) {
        const inputs = $$('input[type="number"]',steps[1]);
        if (inputs.some(el => !el.value || !el.checkValidity())) { showError(error,'Vul een geldige breedte en hoogte in, of kies “Ik weet de maten nog niet”.'); inputs.find(el => !el.value || !el.checkValidity())?.focus(); return; }
      }
      if (step < 3) showStep(step+1); else advise();
    };
    next.addEventListener('click', advance);
    finderForm.addEventListener('submit', e => { e.preventDefault(); advance(); });
    $('[data-finder-back]', finder).addEventListener('click', () => showStep(step-1));
    $('[data-finder-edit]', finder).addEventListener('click', () => showStep(0));
    $('[name="unknown_size"]', finder).addEventListener('change', e => { $$('input[type="number"]',steps[1]).forEach(el => { el.disabled = e.target.checked; }); });
    document.addEventListener('click', e => { const link = e.target.closest('[data-finder-open]'); if (link && openDialog(finder)) { e.preventDefault(); if (!finderForm.hidden) showStep(step); track('finder_opened'); } });
  }
  const initCalculator = form => {
    if (form.dataset.calculatorReady) return;
    form.dataset.calculatorReady = 'true';
    const scope = form.closest('.w-calculator');
    const copy = parse($('[data-calculator-copy]',scope));
    const interpolate = (text, values) => String(text || '').replace(/\{(\w+)\}/g, (_,key) => values[key] ?? '');
    const currency = value => new Intl.NumberFormat('nl-NL',{style:'currency',currency:'EUR'}).format(value);
    let period = 5, updateTimer, lastResult;
    const output = $('[data-calc-output]',scope);
    const calculate = (announce = false) => {
      if (!form.checkValidity()) { output.hidden=true; const intro=$('[data-calc-intro]',scope); intro.textContent=copy.invalid; intro.hidden=false; return false; }
      const values = Object.fromEntries([...new FormData(form)].map(([k,v]) => [k,Number(v)]));
      if (Object.values(values).some(v => !Number.isFinite(v))) return false;
      const select = $('[name="capacity"]',form), selected = select.selectedOptions[0];
      const bigger = [...select.options].filter(o => Number(o.value) > values.capacity).sort((a,b) => Number(a.value)-Number(b.value))[0];
      const result = window.WaterdealCore.calculate(values,Number(bigger?.value) || null,period);
      lastResult = result;
      $('[data-calc-intro]',scope).hidden = true; output.hidden = false;
      $('[data-calc-potential]',scope).textContent = number(result.potential);
      const usable=$('[data-calc-usable]',scope);animateNumber(usable,result.useful,number,Number(usable.dataset.numericValue||0),announce);
      $('[data-calc-usable-a11y]',scope).textContent=number(result.useful);
      $('[data-calc-cans]',scope).textContent = number(result.cans);
      const totalText=currency(result.totalSaving);
      const saving=$('[data-calc-saving]',scope);animateNumber(saving,result.totalSaving,currency,Number(saving.dataset.numericValue||0),announce);
      $('[data-calc-saving-a11y]',scope).textContent=totalText;
      $('[data-calc-saving]',scope).toggleAttribute('data-long',totalText.length>9);
      $('[data-calc-annual]',scope).textContent = currency(result.saving);
      $('[data-calc-years]',scope).textContent = result.years;
      $('[data-calc-fill]',scope).style.width = `${result.annualUse ? Math.min(100,result.useful/result.annualUse*100) : 0}%`;
      $('[data-calc-larger]',scope).textContent = result.extra > 0 ? interpolate(copy.higher,{liters:number(result.extra),capacity:bigger.value}) : result.useful > 0 ? interpolate(bigger ? copy.right_size : copy.largest,{liters:number(result.useful)}) : copy.zero;
      $('[data-calc-assumptions]',scope).textContent = interpolate(copy.assumptions,{rate:currency(values.rate),fills:values.fills,years:period});
      const link = $('[data-calc-product]',scope);
      if (selected?.dataset.productUrl) link.href = selected.dataset.productUrl;
      link.textContent = interpolate(copy.view,{capacity:values.capacity});
      $('[data-calc-stock]',scope).textContent = selected?.dataset.available === 'true' ? copy.stock : copy.sold_out;
      if (announce) $('[data-calc-announcement]',scope).textContent = interpolate(copy.summary,{money:currency(result.saving),liters:number(result.useful)});
      return true;
    };
    form.addEventListener('invalid',e => { const details=e.target.closest('details'); if (details) details.open=true; },true);
    form.addEventListener('submit',e => {
      e.preventDefault();
      if (!form.reportValidity() || !calculate(true)) return;
      $('[data-calc-focus]',scope).focus({preventScroll:true});
      $('[data-calc-focus]',scope).scrollIntoView({block:'center',behavior:motionEnabled()?'smooth':'auto'});
      track('calculator_completed',{capacity:Number(form.elements.capacity.value),period,saving_per_year:lastResult.saving});
    });
    form.addEventListener('input',() => {
      $$('[data-calc-preset]',scope).forEach(button=>button.setAttribute('aria-pressed','false'));
      clearTimeout(updateTimer); updateTimer=setTimeout(()=>calculate(true),280);
    });
    $$('[data-calc-period]',scope).forEach(button => button.addEventListener('click',() => {
      period=Number(button.dataset.calcPeriod);
      $$('[data-calc-period]',scope).forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
      if (calculate(true) && motionEnabled()) $('[data-calc-saving]',scope).animate([{opacity:.3,transform:'translateY(10px)'},{opacity:1,transform:'none'}],{duration:360,easing:'cubic-bezier(.2,.65,.3,1)'});
    }));
    const presets={pots:{capacity:100,use:50,weeks:26,fills:12},garden:{capacity:250,use:100,weeks:26,fills:12},intensive:{capacity:380,use:250,weeks:30,fills:18}};
    $$('[data-calc-preset]',scope).forEach(button=>button.addEventListener('click',()=>{
      const preset=presets[button.dataset.calcPreset];
      Object.entries(preset).forEach(([key,value])=>{const input=form.elements[key];if(input.tagName!=='SELECT'||[...input.options].some(o=>Number(o.value)===value)) input.value=value;});
      $$('[data-calc-preset]',scope).forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
      calculate(true);
    }));
    $('[data-calc-presets]',scope).hidden=false;
    $('[data-calc-live-note]',scope).hidden=false;
    calculate();
  };
  $$('[data-calculator]').forEach(initCalculator);
  document.addEventListener('shopify:section:load',e=>$$('[data-calculator]',e.target).forEach(initCalculator));
  const initSizeStudio = root => {
    if(root.dataset.studioReady) return;
    root.dataset.studioReady='true';
    const tabs=$$('[data-size-tab]',root),panels=$$('[data-size-panel]',root);
    if(!tabs.length||!panels.length) return;
    const select = (tab,focus=false) => {
      tabs.forEach(button=>{const active=button===tab;button.setAttribute('aria-selected',String(active));button.tabIndex=active?0:-1;});
      panels.forEach(panel=>{
        const active=panel.dataset.sizePanel===tab.dataset.sizeTab;
        panel.hidden=!active;
        panel.setAttribute('role','tabpanel');
        panel.setAttribute('aria-labelledby',`w-size-tab-${panel.id.slice('w-size-panel-'.length)}`);
        if(active&&focus){$$('[data-counter]',panel).forEach(el=>animateNumber(el,Number(el.dataset.counter)));}
        if(active&&focus&&motionEnabled()) $('.w-studio-image img',panel)?.animate([{opacity:.3,transform:'translateY(12px) scale(.97)'},{opacity:1,transform:'none'}],{duration:450,easing:'cubic-bezier(.16,1,.3,1)'});
      });
      if(focus) tab.focus({preventScroll:true});
    };
    tabs.forEach((tab,index)=>{
      tab.addEventListener('click',()=>{select(tab,true);track('size_compared',{capacity:Number(tab.dataset.capacity)});});
      tab.addEventListener('keydown',e=>{const keys={ArrowRight:(index+1)%tabs.length,ArrowLeft:(index+tabs.length-1)%tabs.length,Home:0,End:tabs.length-1};if(e.key in keys){e.preventDefault();select(tabs[keys[e.key]],true);}});
    });
    select(tabs.find(tab=>tab.dataset.capacity==='250')||tabs[0]);
    $('[data-size-tabs]',root).hidden=false;
  };
  $$('[data-size-studio]').forEach(initSizeStudio);
  document.addEventListener('shopify:section:load',e=>$$('[data-size-studio]',e.target).forEach(initSizeStudio));
  $$('[data-toc]').forEach(toc => {
    const body = $('[data-article-content]'); if (!body) return;
    const headings = $$('h2,h3',body); if (headings.length < 2) { toc.hidden = true; return; }
    const list = document.createElement('ol'); headings.forEach((heading,i) => { if (!heading.id) heading.id = `artikel-onderwerp-${i+1}`; const li = document.createElement('li'), a = document.createElement('a'); a.href = `#${heading.id}`; a.textContent = heading.textContent; li.append(a); list.append(li); });
    $('ol',toc)?.replaceWith(list); toc.hidden = false;
  });
  $('[data-city-filter]')?.addEventListener('input', e => { let count = 0; $$('[data-city-list] li').forEach(el => { el.hidden = !el.textContent.toLocaleLowerCase('nl').includes(e.target.value.trim().toLocaleLowerCase('nl')); if (!el.hidden) count++; }); $('[data-city-empty]').hidden = count > 0; });
  $$('[data-content-nav]').forEach(nav=>{
    const body=$('[data-content-nav-body]');if(!body)return;
    const headings=$$('h2',body);if(headings.length<2)return;
    const list=$('ol',nav);headings.forEach((heading,index)=>{
      if(!heading.id)heading.id=`waterdeal-onderwerp-${index+1}`;
      const li=document.createElement('li'),link=document.createElement('a');link.href=`#${heading.id}`;link.textContent=heading.textContent;li.append(link);list.append(li);
    });nav.hidden=false;
  });
  const initFAQ = scope => $$('[data-faq-page]',scope).forEach(page=>{
    if(page.dataset.faqReady)return;page.dataset.faqReady='true';
    const input=$('[data-faq-search]',page),status=$('[data-faq-status]',page),groups=$$('.w-service-group',page),questions=$$('details.w-faq',page);
    const initial=new Map(questions.map(item=>[item,item.open]));
    const normalize=text=>text.toLocaleLowerCase('nl').normalize('NFD').replace(/[\u0300-\u036f]/g,'');
    input.addEventListener('input',()=>{
      const words=normalize(input.value.trim()).split(/\s+/).filter(Boolean);let count=0;
      questions.forEach(item=>{const matches=words.every(word=>normalize(item.textContent).includes(word));item.hidden=!matches;item.open=words.length?matches:initial.get(item);if(matches)count++;});
      groups.forEach(group=>group.hidden=!$$('details.w-faq',group).some(item=>!item.hidden));
      status.textContent=words.length?`${count} ${count===1?status.dataset.countSingle:status.dataset.countLabel}`:'';
      $('[data-faq-empty]',page).hidden=count>0;
      const jumps=$('.w-product-jump',page);if(jumps)jumps.hidden=words.length>0;
    });$('[data-faq-search-wrap]',page).hidden=false;
  });
  initFAQ(document);
  document.addEventListener('shopify:section:load',e=>initFAQ(e.target));
  const mobileFooter = matchMedia('(max-width: 749px)');
  const initFooter = scope => {
    $$('[data-footer-group]',scope).forEach(group => {
      if (group.dataset.footerReady) return;
      group.dataset.footerReady = 'true';
      const summary = $('summary',group);
      const setMode = () => { group.open = !mobileFooter.matches; summary.tabIndex = mobileFooter.matches ? 0 : -1; };
      setMode();
      mobileFooter.addEventListener('change',setMode);
      summary.addEventListener('click',e => { if (!mobileFooter.matches) e.preventDefault(); });
    });
  };
  initFooter(document);
  document.addEventListener('shopify:section:load',e => initFooter(e.target));
  document.addEventListener('click',e => {
    $$('.w-mobile-nav[open]').forEach(menu => {
      if (!menu.contains(e.target) || e.target.closest('a')) menu.open = false;
    });
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') $$('.w-mobile-nav[open]').forEach(menu => { menu.open = false; $('summary',menu).focus(); });
  });
  const activeMotion = new Set();
  const revealTargets = '.w-heading,[data-motion],.w-card,.w-article-card,.w-guide-steps>div,.w-tools>a,.w-page-head h1,.w-page-head .w-lead,.w-route-list>a,.w-service-group,.w-contact-method,.w-page-next';
  const reveal = 'IntersectionObserver' in window ? new IntersectionObserver(entries=>{
    entries.forEach(entry=>{
      if(!entry.isIntersecting) return;
      const el=entry.target;
      reveal.unobserve(el);
      if(!motionEnabled()||!el.animate) return;
      const siblings=[...el.parentElement.children].filter(node=>node.matches(revealTargets));
      const delay=Math.min(Math.max(0,siblings.indexOf(el))*65,195);
      const animation=el.animate([{opacity:.5,transform:'translateY(18px)'},{opacity:1,transform:'translateY(0)'}],{duration:650,delay,easing:'cubic-bezier(.16,1,.3,1)'});
      activeMotion.add(animation);animation.finished.finally(()=>activeMotion.delete(animation)).catch(()=>{});
    });
  },{threshold:.08,rootMargin:'0px 0px -28px 0px'}) : null;
  const playRain = scene => {
    if(!motionEnabled()) return;
    scene.classList.remove('is-playing');
    requestAnimationFrame(()=>requestAnimationFrame(()=>scene.classList.add('is-playing')));
  };
  const rainObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries=>{
    entries.forEach(entry=>{if(entry.isIntersecting){playRain(entry.target);rainObserver.unobserve(entry.target);}});
  },{threshold:.4}) : null;
  const counterObserver='IntersectionObserver' in window?new IntersectionObserver(entries=>{
    entries.forEach(entry=>{if(entry.isIntersecting){const el=entry.target;counterObserver.unobserve(el);animateNumber(el,Number(el.dataset.counter));}});
  },{threshold:.8}):null;
  const initMotion = scope => {
    if(counterObserver)$$('[data-counter]',scope).forEach(el=>counterObserver.observe(el));
    $$('details.w-faq,details.w-calc-assumptions',scope).forEach(details=>{
      if(details.dataset.accordionReady)return;details.dataset.accordionReady='true';
      details.addEventListener('toggle',()=>{
        if(details.open&&motionEnabled()){
          const panel=$(':scope>div',details);if(panel?.animate)panel.animate([{opacity:.25,transform:'translateY(-7px)'},{opacity:1,transform:'none'}],{duration:260,easing:'ease-out'});
        }
      });
    });
    if(reveal) $$(revealTargets,scope).forEach(el=>{if(!el.dataset.motionReady){el.dataset.motionReady='true';reveal.observe(el);}});
    $$('[data-rain-scene]',scope).forEach(scene=>{
      if(scene.dataset.rainReady) return;
      scene.dataset.rainReady='true';
      const replay=$('[data-rain-replay]',scene);
      replay.hidden=!motionEnabled();
      replay.addEventListener('click',()=>playRain(scene));
      if(rainObserver)rainObserver.observe(scene);else playRain(scene);
    });
  };
  initMotion(document);
  const updateMotionPreference=()=>{
    if(!motionEnabled()){
      activeMotion.forEach(animation=>animation.finish());finishNumbers();
      document.getAnimations?.().forEach(animation=>{if(animation.effect?.target?.closest?.('.wd')){try{animation.finish();}catch{animation.cancel();}}});
    }
    $$('[data-rain-replay]').forEach(button=>button.hidden=!motionEnabled());
    $$('[data-motion-toggle]').forEach(button=>{button.hidden=config.motion===false;button.setAttribute('aria-pressed',String(!motionEnabled()));});
  };
  const initMotionControls=scope=>$$('[data-motion-toggle]',scope).forEach(button=>{
    if(button.dataset.toggleReady)return;button.dataset.toggleReady='true';
    button.addEventListener('click',()=>{
      const off=!document.documentElement.classList.contains('w-reduce-motion');
      document.documentElement.classList.toggle('w-reduce-motion',off);
      try{localStorage.setItem('waterdeal-motion',off?'off':'on');}catch{}
      updateMotionPreference();
    });
  });
  initMotionControls(document);updateMotionPreference();
  reducedMotion.addEventListener('change',updateMotionPreference);
  document.addEventListener('shopify:section:load',e=>{initMotionControls(e.target);updateMotionPreference();});
  document.addEventListener('shopify:section:load',e=>initMotion(e.target));
})();
